/**
 * @generated SignedSource<<43f7b78066bf64e5a3e464abed0a65e4>>
 * @relayHash 99338068e4e017449f36a50fe15f7c57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f7349b7c529d158a24b29a281d213f66e647aa8b0026607697b85639ba82d566

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraConfigStateConfigurationStatus = "CONFIGURED" | "NOT_CONFIGURED" | "NOT_INSTALLED" | "NOT_SET" | "PARTIALLY_CONFIGURED" | "PROVIDER_ACTION_CONFIGURED" | "PROVIDER_ACTION_NOT_CONFIGURED" | "%future added value";
export type homePageMainQuery$variables = {
  cloudID: string;
};
export type homePageMainQuery$data = {
  readonly jira: {
    readonly devOps: {
      readonly configStates: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly config: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly status: JiraConfigStateConfigurationStatus | null | undefined;
                } | null | undefined;
              }> | null | undefined;
            } | null | undefined;
            readonly id: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"capabilities_IntegrationsConfigStates" | "manage_IntegrationsConfigStates">;
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type homePageMainQuery = {
  response: homePageMainQuery$data;
  variables: homePageMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudID"
  },
  {
    "kind": "Literal",
    "name": "providerTypeFilter",
    "value": [
      "DEVELOPMENT_INFO"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "status"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "homePageMainQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraAppConfigStateConnection",
                "kind": "LinkedField",
                "name": "configStates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraAppConfigStateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "manage_IntegrationsConfigStates"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "capabilities_IntegrationsConfigStates"
                      },
                      {
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "concreteType": "JiraConfigStateConnection",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraConfigStateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraConfigState",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "homePageMainQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraAppConfigStateConnection",
                "kind": "LinkedField",
                "name": "configStates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraAppConfigStateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appDisplayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "appIconLink"
                          },
                          {
                            "concreteType": "JiraConfigStateConnection",
                            "kind": "LinkedField",
                            "name": "config",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraConfigStateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraConfigState",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "configureLink"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f7349b7c529d158a24b29a281d213f66e647aa8b0026607697b85639ba82d566",
    "metadata": {},
    "name": "homePageMainQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "52d58e18a7195a30a2d154faa42a11a8";

export default node;
